// Portfolio Administration v1.0 PR 5 — Cost Ledger tab on the Local
// Enforcer registry detail page. The cross-loan WorkoutCostEntry
// aggregation endpoint (GET /local-enforcers/{id}/cost-ledger) is
// covered in the "When to ask back" notes of the PR brief — adding it
// involves a new service method, so the panel currently renders an
// empty state pointing the user at each Loan's Defaults &amp; Workout
// tab where the per-loan costs live today.

import { EmptyTabCard } from "@/components/portfolioAdmin/registry/EmptyTabCard";

export function EnforcerCostLedgerTab() {
  return (
    <EmptyTabCard
      title="Cost ledger"
      description="Per-loan workout costs (legal fees / court costs / appraisal / etc.) attributed to this enforcer are recorded today on the Defaults & Workout tab of each Loan. A cross-portfolio rollup endpoint is planned as a small additive read-only API; until it ships, drill into the loan-level costs from the Engagements tab."
      testId="enforcer-cost-ledger-tab"
    />
  );
}
